export const TARGET_FILE = 'tsconfig'
